import React, { useContext } from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Global from "../../util/Global";
import { AlertContext } from "../../util/Alerter";
import { LoaderComponent } from "../../util/Loader";
import { GlobalData } from "../../util/GlobalData";
import { FormControl, InputAdornment, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import ImageUploader from "../ImageUploader";
import CategoryIcon from '@mui/icons-material/Category';
import DescriptionIcon from '@mui/icons-material/Description';
import { useNavigate } from "react-router-dom";
import SubtitlesIcon from '@mui/icons-material/Subtitles';



export default function AdsEditComponent({ adsResponseData }) {
  const { t } = useTranslation();
  const navigate = useNavigate()
  const userId = localStorage.getItem("id")
  const { showAlert } = useContext(AlertContext)
  const [isLoading, setisloading] = useState(true)
  const maxImages = 1





  const [title, settitle] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("")
  const [images, setImages] = useState([]);


  const [errors, setErrors] = useState({
    title: false,
    description: false,
    category: false,
    images: false,
  });


  const ADD_AD_URL = Global.backend + "/index.php/api/nouveauAnnonce";
  const UPDATE_AD_URL = Global.backend + "/index.php/api/editAnnonce";




  useEffect(() => {
    checkProvidedProduct()
    setisloading(false)
  }, [])


  // check if we already passed product details
  const checkProvidedProduct = () => {
    if (!adsResponseData) {
      return
    }



    settitle(adsResponseData.titre);
    setDescription(adsResponseData.description);
    setCategory(adsResponseData.categorie);
    setImages([{ imageURL: adsResponseData.image }]);
  }



  const onImageDelete = async (imageId) => {
    return
    const DELETE_IMAGE_URL = Global.backend + "/index.php/produit/deleteImage";

    try {
      await axios.post(DELETE_IMAGE_URL, { imageId });
    } catch (err) {
      showAlert("error", t("request.errorDeleteImage"));
      throw ""
    }
  }

  const checkInputs = () => {
    const errors = {
      title: title.length < 4,
      description: description.length < 5,
      category: !category,
      images: images.length === 0,
    };

    setErrors(errors)



    const hasErrors = Object.values(errors).some(error => error)

    if (hasErrors) {
      let errorMessage = t("ads.verifyDetails")

      showAlert("error", errorMessage)
    }


    return !hasErrors
  }



  function onSubmit() {
    if (!checkInputs()) {
      return
    }

    setisloading(true);

    const formData = new FormData();




    formData.append('titre', title);
    formData.append('description', description);
    formData.append('categorie', category);





    if (!adsResponseData) {
      // add ad

      formData.append(`image`, images[0].file);

      axios
        .post(ADD_AD_URL, formData)
        .then((response) => {
          if (response.data.message == "ok") {
            showAlert("success", t("request.successAddAd"))
            navigate("/dashboard/user/mesannonces")
          } else {
            throw ""
          }
        }).catch((err) => {
          showAlert("error", t("request.errorAddAd"))
        })
        .finally(() => {
          setisloading(false);
        });
    } else {
      // update ad
      formData.append("annonceId", adsResponseData.id);



      if (!images[0].imageURL) {
        // only add local images and not already uploaded images
        formData.append(`image`, images[0].file);
      }


      axios
        .post(UPDATE_AD_URL, formData)
        .then((response) => {
          if (response.data.message == "ok") {
            showAlert("success", t("request.successUpdateAd"))
          } else {
            throw ""
          }
        }).catch((err) => {
          showAlert("error", t("request.errorUpdateAd"))
        })
        .finally(() => {
          setisloading(false);
        });
    }


  }


  return (
    <LoaderComponent isLoading={isLoading}>

      <div className="container-fluid">

        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <div
                  id="addproduct-nav-pills-wizard"
                  className="twitter-bs-wizard"
                >
                  <div className=" twitter-bs-wizard-tab-content">



                    <div className="tab-pane" id="basic-info">
                      <h4 className="card-title">{t("ads.details")}</h4>
                      <p className="card-title-desc"></p>


                      <div className="row mb-3">
                        <div className="col-6">
                          <TextField value={title} error={errors.title} fullWidth variant="outlined" type="text" label={t("ads.title")} onChange={(e) => settitle(e.target.value)}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <SubtitlesIcon />
                                </InputAdornment>
                              )
                            }} />
                        </div>
                        <div className="col-6">
                          <FormControl error={errors.category} fullWidth>
                            <InputLabel>{t("product.categorie")}</InputLabel>
                            <Select
                              IconComponent={CategoryIcon}
                              value={category}
                              label={t("ads.category")}
                              onChange={(e) => setCategory(e.target.value)}
                            >
                              {GlobalData.ads.categories.map((val, index) => {
                                return (
                                  <MenuItem key={index} value={val}>{t("ads.categories." + val)}</MenuItem>
                                )
                              })}
                            </Select>
                          </FormControl>
                        </div>
                      </div>


                      <div className="mb-3">


                        <div className="mb-3">
                          <TextField
                            error={errors.description}
                            fullWidth
                            multiline
                            rows={4}
                            variant="outlined"
                            label={t("ads.description")}
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <DescriptionIcon />
                                </InputAdornment>
                              )
                            }}
                          />
                        </div>



                        <ImageUploader error={errors.images} images={images} maxImages={maxImages} setImages={setImages} onImageDelete={onImageDelete} setisLoading={setisloading} />
                      </div>









                      <div
                        className="tab-pane"
                        id="metadata"
                        style={{ cursor: "pointer" }}
                      >
                        <ul className="pager wizard twitter-bs-wizard-pager-link">
                          <li
                            className="float-end"
                            style={{ cursor: "pointer" }}
                          >

                            <a onClick={() => { onSubmit() }}>
                              {adsResponseData ? t("ads.saveAd") : t("ads.addAd")}
                              <i className="mdi mdi-arrow-right ml-1"></i>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LoaderComponent>
  )

};
